import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ordersBasePath, orderDetailPath, listeordersPath } from './constants';
import { OrderRoot, OrderDetail, ListeOrders } from './views';

export const OrderRouter: RouteObject = {
    path: ordersBasePath,
    element: <OrderRoot />,
    handle: { title: 'Commandes' },
    children: [
        {
            path: listeordersPath,
            element: <ListeOrders />,
            handle: { title: 'Commandes - Liste' },
        },
        {
            path: orderDetailPath,
            element: <OrderDetail />,
            handle: { title: 'Commandes - Détails' },
        },
    ],
};
